module.exports = __webpack_public_path__ + "img/mark-A2.d7d3e76.svg";